export const normalizeStoreName = (name) => {
  if (!name) return '';
  return name.toLowerCase().replace(/[- ]/g, '');
};

export const areStoreNamesEqual = (name1, name2) => {
  return normalizeStoreName(name1) === normalizeStoreName(name2);
};
